// Copyright (c) Docugami, Inc. All rights reserved.

import { chunkHintColor, chunkSelectedColor } from "components/shell/presentation/AppStyles";
import { Component, ComponentId } from "sdv/engine/Component";
import { Point } from "sdv/Types";
import { AnimationCurveType } from "utils/Easings";

export interface BreakHyperlineSettings {
    timeThresholdMs: number;
    movementThresholdPixels: number;
    defaultColor: string;
    pulseColor: string;
    pulseEnterDurationMs: number;
    pulseExitDurationMs: number;
    pulseHoldDurationMs: number;
    pulseIntervalDurationMs: number;
    pulseEnterAnimationCurve: AnimationCurveType;
    pulseExitAnimationCurve: AnimationCurveType;
}

const defaultBreakHyperlineSettings: BreakHyperlineSettings = {
    timeThresholdMs: 1500,
    movementThresholdPixels: 5,
    defaultColor: chunkSelectedColor,
    pulseColor: chunkHintColor,
    pulseEnterDurationMs: 200,
    pulseExitDurationMs: 300,
    pulseHoldDurationMs: 200,
    pulseIntervalDurationMs: 500,
    pulseEnterAnimationCurve: "easeInCubic",
    pulseExitAnimationCurve: "easeInCubic"
}

let debugBreakHyperlineSettings: BreakHyperlineSettings | null = null;

export function getBreakHyperlineSettings() {
    return debugBreakHyperlineSettings || { ...defaultBreakHyperlineSettings }
}

export function setDebugBreakHyperlineSettings(settings: BreakHyperlineSettings | null) {
    debugBreakHyperlineSettings = settings;
}

export interface BreakHyperlineComponent extends Component {
    typeId: ComponentId.BreakHyperline;
    settings: BreakHyperlineSettings;
    startCursor: Point;
    accumulator: number;
    startHyperlineId: string;
    currentAnimationTime?: number;
}
